import React from 'react';
import { NSCard } from 'bricks';
import RenderIf from 'components/RenderIf/RenderIf';
import ProjectActualsIcon from '../ProjectActualsIcon/ProjectActualsIcon';

export interface IMetricOutputCardProps {
    label: string;
    showInProgress?: boolean;
    value?: string | number;
    showProjectActualsIcon?: boolean;
    projectActualsIconName?: string;
}

const MetricOutputCard = ({
    showInProgress, label, value, showProjectActualsIcon, projectActualsIconName,
}: IMetricOutputCardProps) => (
    <NSCard className="NSCard--level-3 h-100 p-2">
        <div>
            <div className="d-flex">
                <RenderIf isTrue={showProjectActualsIcon}>
                    <ProjectActualsIcon
                        name={projectActualsIconName!}
                        className="my-auto mr-1"
                    />
                </RenderIf>
                <p className="mb-0">{label}</p>
            </div>
            <RenderIf isTrue={!showInProgress}>
                <p className="mb-0 text-dark">
                    {value}
                </p>
            </RenderIf>
            <RenderIf isTrue={showInProgress}>
                <p className="mb-0 text-dark font-italic">In progress</p>
            </RenderIf>
        </div>
    </NSCard>
);

export default MetricOutputCard;
